import i18n from '@/lib/i18n'
import UserInfo from '@/lib/user-info'
import StripeInfo from '@/lib/stripe-info'
import * as Constants from '@/lib/constants'
import * as Filter from '@/lib/filters'
import Currency from '@/lib/currency'
import StripePaymentMethodTypes from '@/lib/stripe-payment-method-types'

export default {
  data() {
    return {
      billingPlans: [],
      selectedBillingPlan: null,
      selectedCurrencyItem: null,
      planMode: Constants.STANDARD_PLAN,
      couponCode: null,
      selectedPaymentMethodType: StripePaymentMethodTypes.getItemByStripePaymentMethodType(
        StripePaymentMethodTypes.Card
      ),
      addCardRequest: null,
    }
  },
  computed: {
    billingPurchaseButtonText() {
      if (UserInfo.isTrialAvailable()) {
        return i18n.tt('customBillingPurchase')
      }
      return i18n.tt('customBillingPurchaseWithoutTrial')
    },
    defaultCard() {
      return StripeInfo.getDefaultCard()
    },
    stripeCurrency() {
      return StripeInfo.getCurrency()
    },
    creditCard() {
      return StripeInfo.getDefaultCard()
    },
    trialAvailable() {
      return UserInfo.isTrialAvailable()
    },
  },
  methods: {
    initBillingPlans(plan) {
      let currency = this.stripeCurrency
      if (!currency) {
        if (this.selectedCurrencyItem) {
          currency = this.selectedCurrencyItem.value
        }
      }
      this.billingPlans = this.$store.getters.billingPlans
        .filter(function(element) {
          if (currency) {
            if (currency === element.currency) {
              if (plan === element.plan) {
                // standardの場合はfromStandardがtrueのもののみ対象

                if (element.metadata) {
                  if (UserInfo.hasStandardFunctionality()) {
                    if (element.metadata.fromStandard === 'true') {
                      return element
                    }
                  } else {
                    if (element.metadata.fromStandard !== 'true') {
                      return element
                    }
                  }
                }
              }
            }
          } else {
            if (plan === element.plan) {
              // standardの場合はfromStandardがtrueのもののみ対象
              if (element.metadata) {
                if (UserInfo.hasStandardFunctionality()) {
                  if (element.metadata.fromStandard === 'true') {
                    return element
                  }
                } else {
                  if (element.metadata.fromStandard !== 'true') {
                    return element
                  }
                }
              }
            }
          }
        })
        .sort((a, b) => {
          return a.amount < b.amount ? 1 : -1
        })
    },
    getInvoiceAmountText(amount, currency) {
      if (amount > 0) {
        if (currency === Currency.JPY) {
          return Filter.aidFormatPrice(amount, currency)
        } else {
          return Filter.aidFormatPrice(amount * 0.01, currency)
        }
      }
      return '---'
    },
  },
  watch: {
    selectedCurrencyItem: function(val) {
      this.selectedBillingPlan = null
      // 英語の場合はカードのみ
      if (val) {
        if (this.plan === Constants.PLUS_PLAN) {
          this.stripePaymentMethodTypes = StripePaymentMethodTypes.getStripeCardPaymentMethodTypeOnly()
        } else {
          if (val.value === Currency.JPY) {
            this.stripePaymentMethodTypes = StripePaymentMethodTypes.getStripePaymentMethodTypes()
          } else {
            this.stripePaymentMethodTypes = StripePaymentMethodTypes.getStripeCardPaymentMethodTypeOnly()
          }
        }
      }
      this.initBillingPlans(this.plan)
    },
  },
}
